import loadable from '@loadable/component';

export default loadable(() =>
  import(/* webpackChunkName: "toast" */ './toast-container')
);
